import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { deleteTitle } from "../../../redux/ducks/title";

const DeleteTitle = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deleteTitle, status, error, event] = useStatusThunk(deleteTitle);

    event.onSuccess = () => hide();

    const deleteT = () => {
        { d_deleteTitle({ titleID: props.titleID});
        setTimeout(() => {  window.location.reload(false); }, 3500)}
    }

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete Title</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>
                    <h5 className="info-block" style={{color:'red'}}>Are you sure you want to fully delete this title, and all associated Project Orders?<br/> Once deleted, title and projects cannot be recovered!</h5>
                    <LoadingButton loading={status == "pending"} className="button--danger" onClick={() => deleteT()}>Delete Title/</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeleteTitle;